<template>
  <div v-if="visiblePopups.length > 0" class="popup-overlay">
    <template v-for="(popup, index) in popups">
      <div class="popup" v-if="isPopupVisible(popup.id)" :key="popup.id" :style="popupStyle(index)">
        <img v-if="popup.url" :src="popup.url" alt="공지" @click="routePopupDetail(popup.id)" />

        <!-- 임시 동영상 팝업 -->
        <div v-if="popup.youtubeUrl">
          <iframe width="1240" height="800" :src="popup.youtubeUrl" title="Youtube video player" frameborder="0" allowfullscreen></iframe>
        </div>
        <!-- 임시 동영상 팝업 -->

        <div class="popup-footer">
          <label class="do-not-show">
            <input type="checkbox" @change="dontShowToday(popup.id)" />
            오늘 하루 보지 않기
          </label>
          <v-btn class="button" outlined @click="closePopup(popup.id)">닫기</v-btn>
        </div>
      </div>
    </template>
<!--    <div class="popup-container">-->
<!--      <template v-for="(popup, index) in popups">-->
<!--        <div-->
<!--            v-if="isPopupVisible(popup.id)"-->
<!--            :key="popup.id"-->
<!--            class="popup" :style="popupStyle(index)"-->
<!--        >-->
<!--          <div class="popup-content">-->
<!--            <img v-if="popup.url" class="popup-image" :src="popup.url" alt="공지" @click="routePopupDetail(popup.id)" />-->
<!--          </div>-->

<!--          <div class="popup-footer">-->
<!--            <label class="do-not-show">-->
<!--              <input type="checkbox" @change="dontShowToday(popup.id)" />-->
<!--              오늘 하루 보지 않기-->
<!--            </label>-->
<!--            <v-btn class="button" outlined @click="closePopup(popup.id)">닫기</v-btn>-->
<!--          </div>-->
<!--        </div>-->
<!--      </template>-->
<!--    </div>-->
  </div>
</template>

<script>
import {axiosInstance} from "@/util/AxiosModule";
import router from "@/router";
import store from "@/store";

export default {
  name: "NoticePopup",
  data() {
    return {
      windowWidth: window.innerWidth,
      popups: []
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  mounted() {
    this.getPopupContents();
  },
  computed: {
    visiblePopups() {
      return this.popups.filter(popup => this.isPopupVisible(popup.id));
    },
    isValidDate() {
      const now = new Date();
      const today =
          now.getFullYear().toString() +
          String(now.getMonth() + 1).padStart(2, "0") +
          String(now.getDate()).padStart(2, "0");

      return today <= "20260331";
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    async getPopupContents() {
      try {
        const { data } = await axiosInstance.get("/private/board/popup-list");
        if (data.length > 0) {
          this.popups = data;
          await this.getPopupData(data);
        } else {
          this.popups = [];
        }
      } catch (error) {
        await this.showAlert({ message: "관리자에게 문의해주세요." });
      }
      if (this.isValidDate) {
        if (this.popups.length >= 2) {
          this.popups[1] = [];
        }
        this.popups.push({
          id: 999,
          youtubeUrl: "https://www.youtube.com/embed/Y7s5usZ224M",
          visible: true
        });
      }
    },
    async getPopupData(data) {
      let fileData = [];
      for (let i = 0; i < data.length; i++) {
        const fileType = data[i].files[0].fileType;
        const isImage = ["jpg", "jpeg", "png"].includes(fileType?.toLowerCase());
        if (!isImage) continue;

        try {
          const response = await axiosInstance.get("/private/board/board-file", {
            responseType: "blob",
            params: {
              fileKey: data[i].files[0].fileKey
            }
          });
          const blobUrl = URL.createObjectURL(response.data);
          fileData.push({
            key: data[i].files[0].fileKey,
            url: blobUrl,
            id: data[i].board.boardId,
            visible: true
          });
        } catch (error) {
          await this.showAlert({ message: "관리자에게 문의해주세요." });
        }
      }
      this.popups = fileData.slice(0, 2);
    },
    popupStyle(index) {
      if (this.windowWidth > 1024) {
        return {
          zIndex: 1000 + index
        }
      } else {
        return {
          zIndex: 1000
        }
      }
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    setCookie(name, value) {
      const day = new Date();
      day.setHours(23, 59, 59, 999);
      document.cookie = `${name}=${encodeURIComponent(value)}; expires=${day.toUTCString()}; path=/; Secure; SameSite=Lax`;
    },
    getCookie(name) {
      const cookies = document.cookie.split(";");
      for (let cookie of cookies) {
        let [key, value] = cookie.trim().split("=");
        if (key === name) return value;
      }
      return null;
    },
    dontShowToday(id) {
      this.setCookie(`popup_${id}`, "closed");
      const popup = this.popups.find(popup => popup.id === id);
      if (popup) popup.visible = false;
    },
    closePopup(id) {
      const popup = this.popups.find(popup => popup.id === id);
      if (popup) popup.visible = false;
    },
    isPopupVisible(id) {
      const cookieClosed = this.getCookie(`popup_${id}`) === "closed";
      const popup = this.popups.find(popup => popup.id === id);
      return popup && popup.visible && !cookieClosed;
    },
    async routePopupDetail(id) {
      if (!id) return false;
      await this.getBoardData(id);
      sessionStorage.setItem("boardDetail", JSON.stringify({boardId: id}));
      await router.push({name: "BoardDetail", params: {boardId: id}});
    },
    async getBoardData(boardId) {
      if (!boardId) return false;
      try {
        const { data } = await axiosInstance.get("/private/board/board", {
          params: {
            boardId: boardId
          }
        });
        if (data) {
          await this.getCategoryData(data.board.categoryId);
        }
      } catch (error) {
        await this.showAlert({message: "관리자에게 문의해주세요."});
      }
    },
    async getCategoryData(categoryId) {
      try {
        const { data } = await axiosInstance.get("/private/board/category", {
          params: {
            memberId: store.getters["login/memberId"],
            useYn: "Y"
          }
        });
        data.map(item => {
          if (item.categoryId === categoryId) {
            sessionStorage.setItem("boardDetailList", JSON.stringify(item));
          }
        });
      } catch (error) {
        await this.showAlert({message: "관리자에게 문의해주세요."});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  .popup {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    max-width: 90vw;
    max-height: 90vh;
    background-color: #ffffff;
    padding: 10px;
    border-radius: 5px;
    box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin-top: 35px;
    img {
      max-height: calc(85vh - 40px);
      height: auto;
      object-fit: contain;
    }
    .popup-footer {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}
@media screen and (min-width: 1920px) {

  .popup-overlay {
    display: grid;
    grid-template-columns: repeat(2, 0fr);
    gap: 15px;
    justify-content: center;
    align-items: start;
    .popup {
      position: relative; /* ⭐ 겹침 해제 */
    }
  }
}
</style>